module.exports = ".row{\r\n    padding:20px 0px 20px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.multi-select{\r\n    height: 250px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/formula-details/formula-form/formula-form.component.css
// module id = ./src/app/hrms/payroll/payroll-masters/formula-details/formula-form/formula-form.component.css
// module chunks = main